module.exports = __webpack_public_path__ + "img/document-text.66545eda.svg";